import React, { Fragment, useState } from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { Input } from '@rebass/forms';
import styled from 'styled-components';

const Options = styled(Box)`
  max-height: 200px;
  overflow: auto;
  overflow-x: hidden;
  border-bottom: dashed 2px ${props => props.theme.colors.lilac};
`;

const Option = styled(Flex)`
  cursor: pointer;
  border-radius: 5px;
  background-color: #e5e5ee;
  margin: 0 0 10px 0;
  border: solid 1px ${props => props.theme.colors.lilac};
  &:hover {
    background-color: #c3c1e5;
  }
`;

const InputFilterBox = ({
  name,
  placeholder,
  valuesForm,
  setValuesForm,
  options,
  keyPressHandler
}) => {
  const [showOptions, setShowOptions] = useState(true);

  const selectOption = s => {
    setShowOptions(false);
    setValuesForm({ ...valuesForm, [name]: s });
    document.getElementById(name).focus();
  };

  const handleValueChange = e => {
    let value = e.target.value;
    setValuesForm({ ...valuesForm, [name]: value });
    setShowOptions(true);
  };
  const buttonId = 'b_' + name;
  return (
    <Fragment>
      <Box pb={4}>
        <Input
          id={name}
          name={name}
          type="text"
          onChange={handleValueChange}
          onKeyDown={e => keyPressHandler(e, buttonId, name)}
          placeholder={placeholder}
          value={valuesForm[name]}
          sx={{
            color: `#726DE1`,
            fontSize: `24px`,
            lineHeight: `1.31`,
            letterSpacing: `0.4px`,
            border: `0`,
            borderBottom: `1px solid RGBA(114,109,225,0.3)`,
            outline: `none`,
            paddingY: `5px`,
            paddingX: `0`,
            '&: focus': {
              borderBottom: `2px solid #726DE1`
            },
            ':: placeholder': {
              color: `#726DE1`,
              opacity: `0.3`
            }
          }}
        />
      </Box>
      {valuesForm[name] && showOptions && (
        <Options my={2}>
          {options &&
            options.map(
              (s, index) =>
                s.includes(valuesForm[name].toUpperCase()) && (
                  <Fragment key={index}>
                    <Option
                      alignItems="center"
                      py={2}
                      px={3}
                      width={[1]}
                      onClick={() => selectOption(s)}
                    >
                      <Text color="lilac" fontSize={5}>
                        {s}
                      </Text>
                    </Option>
                  </Fragment>
                )
            )}
        </Options>
      )}
    </Fragment>
  );
};

export default InputFilterBox;
